module.exports = __webpack_public_path__ + "img/1-4.926d0121.svg";